import { render, staticRenderFns } from "./dailyMessage.vue?vue&type=template&id=3dd7b420&scoped=true&"
import script from "./dailyMessage.vue?vue&type=script&lang=js&"
export * from "./dailyMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd7b420",
  null
  
)

export default component.exports